import {
  Directive,
  Output,
  Input,
  EventEmitter,
  HostListener
} from '@angular/core';

@Directive({
  selector: '[appDragAndDrop]'
})
export class DragAndDropDirective {
  constructor() {}

  @Output() fileDropped = new EventEmitter<any>();
  @Input() preventBodyDrop = true;

  @HostListener('window:dragenter', ['$event'])
  onWindowDragEnter(event: any): void {
    event.preventDefault();
    event.stopPropagation();
  }
  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files[0]);
    }
  }
}
